import * as React from 'react';
import { IAlert } from "../../../../share/types/alert";
import { Row, Col, Button } from 'reactstrap';
import { timestampToMoment } from 'src/share/utils/utils';

export interface IAlertCardProps {
    alert: IAlert
    history: any;
}

export const getIcon = (hasError, isStopped, isExpired) => {
    if (hasError) {
        return "fa-exclamation-circle red";
    } else if (isExpired) {
        return "fa-clock-o grey"
    } else if (isStopped) {
        return "fa-times-circle-o grey";
    }
    return "fa-dot-circle-o";
}

export const getAlertStatus = (hasError, isStopped, isExpired) => {
    if (hasError) {
        return "Error";
    } else if (isExpired) {
        return "Expired"
    } else if (isStopped) {
        return "Stopped";
    }
    return "Active";
}

const AlertCard: React.SFC<IAlertCardProps> = (props) => {
    const { caseId, alertId, location, stop, radius, createdAt, expirationDate, expired, error } = props.alert
    const [country, state, city] = location.split(',').reverse();
    const cityFormatted = `${city ? city + ", " : ""}${state || ""}`;
    const isStopped = stop === "Yes" || expired;
    const expiration = isStopped ? '' : `expires ${timestampToMoment(expirationDate).fromNow()}`;
    return (
        <Col className="col-12">
            <div className="info-card white-background alert-card">
                <Row>
                    <Col className={"col-6 location"}>
                        <h4>{country}</h4>
                        {cityFormatted && <p className={"city subFont"}>{cityFormatted}</p>}
                        <p className="date subFont">created {timestampToMoment(createdAt).fromNow()}</p>
                        <p className="date subFont">{expiration}</p>
                    </Col>
                    <Col className={"col-6"}>
                        <p><i className="fa fa-dot-circle-o" aria-hidden="true" /><span className="subFont">{radius} miles radius</span></p>
                        <p>
                            <i className={`fa ${getIcon(error, isStopped, expired)}`} aria-hidden="true" />
                            <span className="subFont">{getAlertStatus(error, isStopped, expired)}</span>
                        </p>
                        <p><b>Case Id: </b><span className="subFont">{caseId}</span></p>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-right" md="12" sm="12" xs="12">
                        <Button onClick={() => props.history.push(`/alerts/edit/${caseId}/${alertId}`)} className={"btn-blue"}>
                            {isStopped ? "View" : "View & edit"}
                        </Button>
                    </Col>
                </Row>
            </div>
        </Col>
    )
};

export { AlertCard };
export default React.memo(AlertCard);